import { Container, Stack, styled } from '@mui/material';
import { ReactElement } from 'react';

import { ContactInformation } from '../components/contact-information';
import { FooterBottom } from '../components/footer-bottom';
import { FooterNews } from '../components/footer-news';
import { FooterService } from '../components/footer-service';
import { SocialMedia } from '../components/social-media';
import { footerSelector } from '../../../store/configuration-selectors';
import { useAppSelector } from '../../../../store/store';

const StyledContainer = styled(Container)(({ theme }) => ({
    height: 304,
    display: 'flex',
    justifyContent: 'space-between',
    gap: 'clamp(16px, 2vw, 40px)',
    paddingTop: theme.spacing(8),
    color: theme.palette.grey[500],
}));

export const DesktopFooter = (): ReactElement => {
    const footer = useAppSelector(footerSelector);

    const contact = footer?.contact && <ContactInformation contact={footer.contact} />;

    return (
        <Stack sx={{ backgroundColor: theme => theme.palette.common.black }}>
            <StyledContainer maxWidth="xl">
                {contact || undefined}
                {footer?.newsLinks && <FooterNews links={footer.newsLinks} />}
                {footer?.serviceLinks && <FooterService links={footer.serviceLinks} />}
                {footer?.socialLinks && <SocialMedia links={footer.socialLinks} />}
            </StyledContainer>
            <FooterBottom links={footer?.bottomLinks || []} />
        </Stack>
    );
};
